<template>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Neuen Fragebogen hinzufügen</h3>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="createForm">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Angaben zum Fragebogen</h6>
                    <Formform :status="status" ref="FForm"/>
                    <button :key="tick+'jgsadsw'" class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Fragebogen {{formButtonText}}</span></button>
                </form>
                    <hr class="my-4" />
                    <!-- Address -->
                <div v-if="showQuestions">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Fragen und mögliche Antworten</h6>
                    <div v-for="(question,index) in questions" class="mb-2" :key="index">
                        <form @submit.prevent="createQuestion(index)" :key="tick" style="width: 100%;">
                        <div class="row align-items-center">
                            <div  class="col-lg-10">
                                <h6 class="heading-small text-muted mb-4">{{ index+1 }}. Frage</h6>
                                <Questionform ref="QForm" :question="question" :socialconcept="$refs.FForm.form.socialconcept"/>
                                <hr class="my-4"/>
                            </div>
                            <div v-if="question.edit" class="col-2">
                                <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                                    <span :key="tick+'shdgj'" class="btn-inner--icon"><i  v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="fas fa-save"></i></span>
                                </button>
                                <base-button v-if="(question.id)" type="primary" icon="far fa-window-close" v-on:click="enableQuestionForm(index)"></base-button>
                            </div>
                            <div  v-else class="col-lg-2">
                                    <base-button type="primary" icon="ni ni-settings-gear-65" v-on:click="enableQuestionForm(index)"></base-button>
                                    <base-button v-if="!question.delete" type="primary" icon="far fa-trash-alt" v-on:click="deleteConfirmation(index)"></base-button>
                                    <div v-if="question.delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="far fa-trash-alt"></i></span><br>
                                        <base-button v-if="question.delete" size="sm" type="danger" icon="fas fa-check" v-on:click="deleteQuestion(index)">Ja</base-button>
                                        <base-button v-if="question.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                                    </div>

                            </div>
                        </div>
                        </form>
                    </div>
                    <a href="#" @click.prevent="questions.push({
                                                                    type: 'single',
                                                                    extra: false,
                                                                    answers: [],
                                                                    rules: [],
                                                                    edit: true
                                                                })">Neue Frage hinzufügen</a><br>
                </div>
            </template>
        </card>
</template>

<script>
    import Formform from "@/views/Forms/Formform";
    import Questionform from "@/views/Forms/Questionform";

    export default {
        name: "create",
        components: {Questionform, Formform},
        data() {
            return {
                isMounted: false,
                isLoading: false,
                tick: 1,
                questions: [{
                    edit: true,
                    delete: false,
                    question: '',
                    description: '',
                    type: '',
                    extra: false,
                    answers: [],
                    rules: []
                }],
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created(){
            if (this.$router.currentRoute.name === "forms_edit") this.getFormAndQuestionData(this.$route.params.id);

        },
        mounted(){
            this.isMounted = true;
        },
        computed: {
            showQuestions() {
                return (this.isMounted) ? (this.$refs.FForm.form.id) : false ;
            },
            formButtonText() {
                return (this.$router.currentRoute.name === "forms_edit") ? 'editieren' : 'anlegen';
            }
        },
        methods: {
            enableQuestionForm(index) {
                this.questions[index].edit = !this.questions[index].edit;
                this.tick++;

            },
            deleteConfirmation(index) {
                this.questions[index].delete = !this.questions[index].delete;
                this.tick++;

            },
            getFormAndQuestionData(id){
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/forms/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$refs.FForm.form = response;
                                this.$refs.FForm.form.action = (typeof response.action !== 'undefined') ? response.action['@id'] : null;
                                this.$refs.FForm.form.socialconcept = (typeof response.socialconcept !== 'undefined') ? response.socialconcept['@id'] : null;
                                this.questions = response.questions;
                                this.tick++;
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                                this.tick++;
                            });
                });
            },
            createForm() {
                return new Promise((resolve, reject) => {
                    this.isLoading = true;
                    this.tick++;
                    const header = this.authHeader();
                    header['Content-Type'] = (!this.$refs.FForm.form.id) ? 'application/json' : 'application/merge-patch+json';
                    let senddata = JSON.parse(JSON.stringify(this.$refs.FForm.form));
                    const requestOptions = {
                        method: (!this.$refs.FForm.form.id) ? 'POST' : 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    let string = (!this.$refs.FForm.form.id) ? 'erstellt' : 'geändert';
                    let url = (!this.$refs.FForm.form.id) ? '/api/forms' : '/api/forms/' + this.$refs.FForm.form.id;
                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.tick++;
                                this.$refs.FForm.form = response;
                                this.status =  {type: 'success', msg: 'Der Fragebogen (ID: '+response.id+') wurde '+string+'. Sie können Fragen und Antworten zu diesem Fragebogen anlegen.'};
                                resolve(response);
                            },
                            error => {
                                this.isLoading = false;
                                this.tick++;
                                this.status =  {type: 'danger', msg: error};
                                reject(error);
                            });
                });
            },
            deleteQuestion(index) {
                return new Promise((resolve, reject) => {
                        this.isLoading = true;
                        const header = this.authHeader();
                        header['Content-Type'] = 'application/json';
                        let senddata = this.questions[index];
                        const requestOptions = {
                            method: 'DELETE',
                            headers: header,
                            body: JSON.stringify(senddata)
                        };
                        if (!this.questions[index].id) {
                            this.questions.splice(index,1);
                            this.isLoading = false;
                            resolve(true);
                        } else {
                            let url = '/api/questions/' + this.questions[index].id;
                            fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                                .then(this.handleResponse)
                                .then(response => {
                                        this.isLoading = false;
                                        this.questions.splice(index,1);
                                        this.status =  {type: 'success', msg: 'Der Frage (ID: '+response.id+') wurde gelöscht.'};
                                        resolve(response);
                                    },
                                    error => {
                                        this.isLoading = false;
                                        this.status =  {type: 'danger', msg: error};
                                        reject(error);
                                    });
                        }
                });
            },
            createQuestion(index) {
                return new Promise((resolve, reject) => {
                    this.isLoading = true;
                    this.tick++;
                    const header = this.authHeader();
                    header['Content-Type'] = (!this.questions[index].id) ? 'application/json' : 'application/merge-patch+json';
                    let senddata = this.questions[index];
                    senddata.form = this.$refs.FForm.form['@id'];
                    const requestOptions = {
                        method: (!this.questions[index].id) ? 'POST' : 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    let string = (!this.questions[index].id) ? 'erstellt' : 'geändert';
                    let url = (!this.questions[index].id) ? '/api/questions' : '/api/questions/' + this.questions[index].id;
                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.tick++;
                                this.questions[index] = response;
                                this.questions[index].edit= false;
                                this.questions[index].delete= false;
                                this.status =  {type: 'success', msg: 'Der Frage (ID: '+response.id+') wurde '+string+'.'};
                                resolve(response);
                            },
                            error => {
                                this.isLoading = false;
                                this.tick++;
                                this.status =  {type: 'danger', msg: error};
                                reject(error);
                            });
                });
            }
        }
    }
</script>

